(function(){
    // open current app
    if (VAR_CURRENT_OPTS){
        let $current_model = $(`#menu-${VAR_CURRENT_OPTS.replace('.', '__')}`);
        if($current_model.length){
            $current_model.parents('.side-menu__submenu').addClass('in');
            $current_model.addClass('side-menu__active');
        }
    }

    var $wrapper = $('#wrapper');
    var $menu_toggle = $("#menu-toggle");
    $menu_toggle.click(function (e) {
        e.preventDefault();
        $wrapper.toggleClass("toggled");
        $.cookie("class_menu", $wrapper.attr('class'), {path: '/'});

    });
    var $menu = $('.side-menu__content');

    $menu.find('i').click(function (e) {
        var $a = $(this).parents('a');
        $wrapper.addClass("toggled");
        //if ($(window).width() <= 578) {
        //    $.removeCookie('class_menu');
        //}else{
        //
        //}
        $.cookie("class_menu", "toggled", {path: '/'});
        $menu.find("li a").addClass('collapse');
        $menu.find("li div").removeClass('in');
        $a.removeClass('collapse');
        $a.next().removeAttr('style').addClass('in');
        location.replace($a.attr('href'));
        e.stopPropagation();
    });

    $('.side-menu__app').on('click', function () {
        if ($('.side-menu__search').val()) {
            var element = $(this);
            element.parent().find('.side-menu__model').css('display', 'block');
            element.next().removeClass('in');
        }
    });

    // search module, product or person
    $('#side-menu__search').change(function () {
        window.location.href = this.value;
    });

}());

